export const requestAndroidAppReview = () => {
  // @ts-ignore
  Android.requestReview()
}

export const hasAndroidAppReviewCapability = (): boolean => {
  // @ts-ignore
  return typeof Android !== 'undefined' && typeof Android.requestReview === 'function';
}